export const CRM_OBJECT_LIFECYCLE_UPDATE = 'CRM_OBJECT_LIFECYCLE_UPDATE';